<template>
  <div class="content-page real-time-info-class">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="addNewsClass"
            >新建分类</el-button
          >
        </div>
        <div class="header-right">
          <el-input
            type="primary"
            size="small"
            v-model="modulesName"
            placeholder="请输入分类名称"
            clearable
            @keydown.enter.native="getScreenData"
          ></el-input>
          <el-select
            popper-class="screen-select"
            v-model="isEnable"
            size="small"
            placeholder="请选择是否可用"
            clearable
          >
            <el-option label="是" :value="1"> </el-option>
            <el-option label="否" :value="0"> </el-option>
          </el-select>
          <el-button type="primary" size="small" @click="getScreenData">筛选</el-button>
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="newsModulesList" style="width: 100%">
            <el-table-column label="分类名称">
              <template slot-scope="scope">
                <div class="name">{{ scope.row.modulesName }}</div>
              </template>
            </el-table-column>
            <el-table-column label="分类类型">
              <template slot-scope="scope">
                <div>{{ typeObj[scope.row.type] }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" header-align="right">
              <template slot-scope="scope">
                <div class="float-right">
                  <el-button
                    size="small"
                    :type="scope.row.isEnable == 1 ? 'danger' : 'success'"
                    @click="updatedNewsClassEnable(scope.row)"
                    plain
                    >{{ scope.row.isEnable == 1 ? "暂停" : "启用" }}</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="editNewsClass(scope.row)"
                    plain
                    >编辑</el-button
                  >
                  <el-button size="small" type="danger" @click="del(scope.row)" plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination> -->
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogBindClassVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
      @close="resetForm"
    >
      <div slot="title" class="dialog-title">
        {{ newsClassForm.shopId ? "编辑分类" : "新建分类" }}
      </div>
      <el-form
        :model="newsClassForm"
        :rules="rules"
        ref="newsClassForm"
        label-width="88px"
        class="demo-ruleForm"
        :hide-required-asterisk="true"
        :validate-on-rule-change="false"
      >
        <div>
          <el-form-item label="分类名称" prop="modulesName">
            <el-input
              v-model="newsClassForm.modulesName"
              placeholder="请填写分类名称"
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="submitForm('newsClassForm')"
          :loading="isSubmit"
        >
          {{ newsClassForm.shopId ? "编辑" : "立即创建" }}</el-button
        >
        <el-button @click="dialogBindClassVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  plusNewsModules,
  modifyNewsModules,
  deleteNewsModules,
  getNewsModulesList,
} from "@/api";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isSubmit: false,
      pageNo: 1,
      pageSize: 5,
      pageCount: 0,
      dialogBindClassVisible: false,
      newsClassForm: {
        modulesName: "",
        isEnable: 1,
        type: 2,
      },
      rules: {
        modulesName: [
          {
            required: true,
            message: "请填写分类名称",
            trigger: "blur",
          },
        ],
      },
      newsModulesList: [],
      typeObj: {
        1: "系统",
        2: "商户",
      },
      isEnable: "",
      modulesName: "",
    };
  },
  computed: {
    ...mapState({
      shop: (state) => state.shopInfo,
    }),
  },
  watch: {
    modulesName(val) {
      if (!val) {
        this.getScreenData();
      }
    },
    isEnable() {
      this.getScreenData();
    },
  },
  components: {},
  mounted() {
    this.getPageData();
  },
  methods: {
    getScreenData() {
      this.pageNo = 1;
      this.getNewsModulesList();
    },
    getPageData(type = "") {
      if (type == "create") {
        this.pageNo = Math.ceil((this.pageCount + 1) / this.pageSize);
      }
      this.getNewsModulesList();
    },
    getNewsModulesList() {
      getNewsModulesList({
        modulesName: this.modulesName,
        isEnable: this.isEnable,
      }).then((res) => {
        if (res.code == 1) {
          this.newsModulesList = res.data;
        } else {
          this.newsModulesList = [];
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    info(index) {},
    addNewsClass() {
      let newsClassForm = JSON.parse(JSON.stringify(this.newsClassForm));
      newsClassForm.modulesName = "";
      newsClassForm.shopAddress = "";
      this.newsClassForm = newsClassForm;
      this.dialogBindClassVisible = true;
    },
    editNewsClass(item) {
      let newsClassForm = JSON.parse(JSON.stringify(item));
      this.newsClassForm = newsClassForm;
      this.dialogBindClassVisible = true;
    },
    submitForm(formName, cb) {
      console.log(this.newsClassForm, "newsClassForm");
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let newsClassForm = JSON.parse(JSON.stringify(this.newsClassForm));
          newsClassForm.modulesId = newsClassForm.id;
          if (newsClassForm.modulesId) {
            modifyNewsModules(newsClassForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "编辑成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindClassVisible = false;
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          } else {
            plusNewsModules(newsClassForm).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "保存成功",
                  type: "success",
                  duration: 2000,
                });
                this.dialogBindClassVisible = false;
                this.getPageData("create");
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "warning",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          this.$notify({
            title: "提示",
            message: "表单未完善，请检查分类设置",
            type: "error",
            duration: 2000,
          });
          return false;
        }
      });
    },
    resetForm() {
      this.newsClassForm = {
        modulesName: "",
        isEnable: 1,
        type: 2,
      };
      this.$refs.newsClassForm.resetFields();
    },
    del(item) {
      this.$msgbox({
        title: "消息",
        message: `是否删除，删除后将无法恢复！`,
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            deleteNewsModules({
              modulesId: item.id,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
            done();
          } else {
            done();
          }
        },
      }).then((action) => {});
    },
    updatedNewsClassEnable(row) {
      modifyNewsModules({
        modulesName: row.modulesName,
        modulesId: row.id,
        isEnable: row.isEnable == 1 ? 0 : 1,
      }).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          row.isEnable = row.isEnable == 1 ? 0 : 1;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    & > div {
      margin-right: 10px;
    }
    .el-input {
      width: 200px;
    }
    .el-select {
      width: 200px;
    }
  }
  .list {
    width: 100%;
    padding: 0 20px;
  }
}
.map {
  width: 100%;
  height: 400px;
  　　/deep/ .anchorBL {
    display: none;
  }
}
.popup-container {
  text-align: center;
  padding-bottom: 10px;
  .qrcode {
    display: block;
    margin: 10px;
  }
}
.demo-ruleForm {
  // height: 500px;
  overflow: auto;
}
</style>
